export default __webpack_public_path__ + "static/media/arriow.d6434980.svg";